export const BANK_TYPE = 'BANK_TYPE';